import type { FaireProductEntity } from "../../entity_types/product";

export const p_4jrxybhgq3: FaireProductEntity = {
  token: "p_4jrxybhgq3",
  type: "product",
  name: "Fresh Coat Daily Cleansing Spray",
  brandToken: "b_bf7zwxbsts",
  brandName: "Dandylion",
  imageUrl: "https://cdn.faire.com/fastly/ae43bbb70caf29a52c92a32cc1c7e39022beace19273602c184524eeb9d07f1c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9289c43c2506d98cf49a30baff772d51bed8c5a004351ab350868ef498dc7968.png",
    "https://cdn.faire.com/fastly/73c330b9a784d0b9de8cdd87d16551e0e4c87f5a458fd421a20b3f9c14e64047.png",
    "https://cdn.faire.com/fastly/89444354de2fca33ada52981a2295e937d3314ed83390ea52ef04aa1f18f6644.png",
    "https://cdn.faire.com/fastly/e92caa5d5da762893cb836f243d0511a4fcf930307f0470dac260a4f8308a4ba.png",
    "https://cdn.faire.com/fastly/0dcf0a52a758d5047879e1403c093c5d9fab4e14939277865d8a00dc4df85a4f.png",
    "https://cdn.faire.com/fastly/1e931c8d635a77945ed10d7e70d31a9c63fe91cd61fe318d205b1fdf8689d762.png",
    "https://cdn.faire.com/fastly/1b8fa55ddacb74e9ae5d056af39766edefad15161edc076b7b76cbc285f2f50f.png",
    "https://cdn.faire.com/fastly/93f13f4868eae31025b27eb5d4acb2b2fee2d9db9dabdbc04af1467142640cf8.png",
    "https://cdn.faire.com/fastly/d6a393e4c76d6f41aeb431646d7c0d96d3eefd0931283c7419dda1e74df45e7e.png",
    "https://cdn.faire.com/fastly/15e297b2efd0d126261f8bd9ef79a26a7b3ee043afaeb29ec04c20dfcdb65003.png"
  ],
  priceDollars: 9,
  description: "Not every day can be a bath day — but every day can be a Fresh Coat day. \n\nWhy we love it: The easiest way to cleanse and refresh coats between baths.\n\nVet-Dermatologist Approved | Fragrance-Free | pH-Balanced for Dogs | Lick-Safe | Vegan | Cruelty-Free\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T16:24:38.449Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
